export function registerServiceWorker(): void {
  if (!("serviceWorker" in navigator)) return;
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {
      // 서비스워커 등록 실패는 치명적이지 않음(PWA 설치만 불가) — 조용히 무시.
    });
  });
}
